import MDTypography from "components/MDTypography";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import MDBox from "components/MDBox";
import colors from "assets/theme-dark/base/colors";
import { styled, keyframes } from "@mui/system";

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const StyledCard = styled(MDBox)`
  width: 100%;
  background: ${colors.background.default};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 1.25rem;
  border: 1px solid ${colors.grey[300]};
`;

const StyledTableContainer = styled(TableContainer)`
  color: ${colors.text.main};
  height: 100%;
  background: transparent;
  border-radius: 0;
  max-height: 500px;
  animation: ${fadeIn} 0.5s ease-out;

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  &::-webkit-scrollbar-track {
    background: ${colors.grey[800]};
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${colors.grey[800]};
    border-radius: 3px;
    cursor: grab;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${colors.grey[800]};
  }

  &::-webkit-scrollbar-thumb:active {
    cursor: grabbing;
  }

  scrollbar-width: thin;
  scrollbar-color: ${colors.grey[800]} ${colors.grey[300]};
`;

const StyledTableRow = styled(TableRow)`
  &:hover {
    background-color: ${colors.grey[300]}10;
  }
`;

function ColumnTable({ column, values }: { column: string; values: string[] }) {
  return (
    <StyledCard>
      <MDBox display="flex" flexDirection="column" alignItems="center" justifyContent="center">
        <StyledTableContainer>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    color: colors.text.main,
                    backgroundColor: colors.grey[200],
                    padding: "10px",
                  }}
                >
                  {column}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {values?.map((value: string, index: number) => (
                <StyledTableRow key={index}>
                  <TableCell
                    sx={{
                      color: colors.text.main,
                      background: "transparent",
                      padding: "10px",
                    }}
                  >
                    {value}
                  </TableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </StyledTableContainer>
        <MDTypography variant="caption" sx={{ color: colors.grey[600], mt: "0.85rem", fontStyle: "italic" }}>
          A peek into the selected column&apos;s data
        </MDTypography>
      </MDBox>
    </StyledCard>
  );
}

export default ColumnTable;
